// Static per-type docType/casing mapping mirroring DefaultObjects/*.ts's hardcoded
// contentType/CommonFields.category values — required for parity with what
// createOldContent/updateOldContent's mutations actually persist.
const FIXED_CONTENT_TYPE_DOC_TYPES: Record<string, string> = {
  article: "Article",
  vod: "Vod",
  quiz: "Quiz",
  poll: "Poll",
  event: "Event",
  formbuilder: "formbuilder",
};

export const resolveSlugDocType = (contentType: string): string =>
  FIXED_CONTENT_TYPE_DOC_TYPES[contentType?.toLowerCase()] ?? contentType;
